import React, { lazy } from 'react';
import { AvatarCallout } from './AvatarCallout';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export interface ItemData {
  number: number;
  title: React.ReactNode;
  titleImages?: Array<{
    url: string;
    alt: string;
  }>;
  mechanism: React.ReactNode;
  avatars: {
    jessica?: React.ReactNode;
    michelle?: React.ReactNode;
  };
  bridge: React.ReactNode;
  image?: {
    url: string;
    alt: string;
  };
  imageOnLeft: boolean;
  bgColor?: string;
  borderBottom?: string;
}
interface ItemSectionProps {
  data: ItemData;
}
export function ItemSection({
  data
}: ItemSectionProps) {
  const {
    ref,
    isVisible
  } = useScrollAnimation(0.2);
  return <section ref={ref} className={`w-full py-10 md:py-12 lg:py-20 px-6 md:px-12 lg:px-20 border-b ${data.borderBottom || 'border-gray-200'} ${data.bgColor || 'bg-white'} scroll-animate ${isVisible ? 'visible' : ''}`} data-id="element-121">
      <div className={`max-w-[1200px] mx-auto flex flex-col ${data.imageOnLeft ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-8 lg:gap-10 items-start`} data-id="element-122">
        {/* Text Content */}
        <div className={`w-full ${data.image ? 'lg:w-[55%]' : 'lg:w-full'} flex flex-col`} data-id="element-123">
          <h3 className="text-[22px] md:text-[24px] lg:text-[29px] font-bold text-brand-teal leading-[1.4] tracking-[-0.3px] mb-3" data-id="element-124">
            {data.number}. {data.title}
          </h3>

          {data.titleImages && data.titleImages.length > 0 && <div className="flex flex-col gap-4 mb-6" data-id="element-125">
              {data.titleImages.map((img, idx) => <div key={idx} className="relative" style={{
            width: '100vw',
            left: '50%',
            marginLeft: '-50vw'
          }} data-id="element-126">
                  <img src={img.url} alt={img.alt} className="w-full h-auto object-cover block" loading="lazy" data-id="element-127" />
                </div>)}
            </div>}

          <p className="text-[16px] text-brand-navy font-normal leading-[1.7] mb-4" data-id="element-128">
            {data.mechanism}
          </p>

          <div className="flex flex-col mb-4" data-id="element-129">
            {data.avatars.jessica && <AvatarCallout name="Jessica" quote={data.avatars.jessica} data-id="element-130" />}
            {data.avatars.michelle && <AvatarCallout name="Michelle" quote={data.avatars.michelle} data-id="element-131" />}
          </div>

          <div className="pt-3 border-t border-brand-goldLight" data-id="element-132">
            <p className="text-[14px] text-brand-navy font-semibold leading-[1.6]" data-id="element-133">
              {data.bridge}
            </p>
          </div>
        </div>

        {/* Image Content */}
        {data.image && <div className={`w-full lg:w-[45%] mt-8 lg:mt-0 ${data.imageOnLeft ? 'lg:mr-10' : 'lg:ml-10'}`} data-id="element-134">
            
          </div>}
      </div>
    </section>;
}